import { type ReactElement } from 'react';
import { useRouter } from 'next/router';
import { type RootLayoutProps } from '@/layout/types';
import { TrialEndDiscountBannerContainer } from '@/module/plan';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { Conditional } from '@/shared/googleClassroom';
import { GnbHeaderForExternalPlatform } from './Header/GnbHeaderForExternalPlatform';
import { GnbHeaderForGoogleClassroom } from './Header/GnbHeaderForGoogleClassroom';
import { ProductHeader } from './Header/ProductHeader';
import { PromotionHeader } from './Header/PromotionHeader';

// 보드 랜딩은 정확히 일치할 때만, 견적 페이지는 제품 헤더를 사용한다.
const PROMOTION_HEADER_EXACT_PATHS = ['/', '/board/landing'];
const PROMOTION_HEADER_PREFIX_PATHS = ['/landing', '/pricing', '/biz'];
const QUOTE_PATH = '/pricing/quote';
export const isPromotionHeaderPath = (pathname: string) => pathname !== QUOTE_PATH && !pathname.startsWith(`${QUOTE_PATH}/`) && (PROMOTION_HEADER_EXACT_PATHS.includes(pathname) || PROMOTION_HEADER_PREFIX_PATHS.some(path => pathname.startsWith(path)));
const RootLayout = (props: RootLayoutProps) => {
  const isInExternalPlatform = useIsInExternalPlatform();
  const router = useRouter();
  const Header = isPromotionHeaderPath(router.pathname) ? PromotionHeader : ProductHeader;
  return <>
      {isInExternalPlatform ? <GnbHeaderForExternalPlatform /> : <Conditional inGoogleClassroom={<GnbHeaderForGoogleClassroom />}>
          {/* 배너는 sticky 헤더 바로 위 문서 흐름에 놓인다 (Figma 29139:3337). */}
          <TrialEndDiscountBannerContainer />
          <Header />
        </Conditional>}
      {props.children}
    </>;
};
export function getRootLayout(page: ReactElement) {
  return <RootLayout data-sentry-element="RootLayout" data-sentry-component="getRootLayout" data-sentry-source-file="getRootLayout.tsx">{page}</RootLayout>;
}
export function getLightLayout(page: ReactElement) {
  return <RootLayout data-sentry-element="RootLayout" data-sentry-component="getLightLayout" data-sentry-source-file="getRootLayout.tsx">{page}</RootLayout>;
}